import React from 'react'
import NavBar from './navbar';
import Profile from './profile';
import Stats from './stats';
import Services from './services';
import Navbar from './navbar';
import Skills from './skills';
import Education from './education';
import Footer from './footer';
import Projects from './projects';
import GithubStats from './githubStats';
import GitJournal from './gitJournal';
import EmploymentHistory from './employment';

const Home = () => {
  return (
    <div className="grid grid-cols-1">
      <Navbar />
      <Profile />
      <Projects />
      <GithubStats />
      <EmploymentHistory />
      {/* <Services /> */}
      <Education />
      <Skills />
      <Footer />
    </div>
  )
}

export default Home